/*
 * Module for an kbLocaleModal item
 */
define([
  "backbone",
  "underscore",
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesList/kbLocalesListView",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/kbAdmin/kbModel",
], function (
  Backbone,
  _,
  Marionette,
  $,
  Messenger,
  KbLocalesListView,
  SortableListModule,
  // eslint-disable-next-line no-unused-vars
  KbModel,
) {
  "use strict";

  var KbLocalesListModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbLocalesList";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },

    show: function (kb) {
      this.kb = kb;

      this.layout = new KbLocalesListView.kbLocalesLayout({
        model: this.kb,
      });

      this.locales = this.kb.getLocales();

      var headers = Messenger.reqres.request("kb:locale:list:headers");
      var extendedEvents = {
        "click .deleteKbLocale": function () {
          Messenger.vent.trigger("update:kb:language:add:clearInput");
          Messenger.vent.trigger("fetch:kb:responseTypeUsage:language:change:decrease");
          Messenger.vent.trigger("view:admin:kbWizard:kbLocale:languages:delete", this.model);
        },
      };

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          extendedEvents: extendedEvents,
          hideHeader: true,
          hideControls: true,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this.list.show(this.locales);
        },
        this,
      );

      this.locales.onSynced(function () {
        this.showRegion(this.layout);
      }, this);
    },

    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },

    isEmpty: function () {
      if (this.locales.length === 0) {
        return true;
      }
      return false;
    },

    saveNewLanguage: function (language) {
      this.layout.clearErrors();
      // Check valid language
      if (!language) {
        this.layout.showErrorMessage($.t("admin.kbAdmin.addLocaleError"));
        return;
      }
      var _this = this;

      // Check for duplicate.
      var duplicate = false;
      this.locales.each(function (model) {
        if (model.get("id") === language.get("id")) {
          duplicate = true;
        }
      });

      if (duplicate) {
        this.layout.showErrorMessage($.t("admin.kbAdmin.duplicateLocaleError"));
        return;
      }
      var newLanguage = this.locales.addItem(language.get("id"), language.get("name"));

      if (this.editMode) {
        newLanguage.save(
          {},
          {
            type: "POST",
            success: function () {
              Messenger.vent.trigger("fetch:kb:responseTypeUsage:language:change:increase");
              Messenger.vent.trigger("update:kb:language:add:clearInput");
            },
            error: function (language, response) {
              _this.locales.remove(language);
              if (response.status === 400) {
                Messenger.okDialog(
                  $.t("admin.kbAdmin.responseTypeCapacityExceeded", {
                    message: response.responseJSON.value,
                  }),
                );
              } else {
                Messenger.showErrorFromResponse(response);
              }
            },
          },
        );
      } else {
        Messenger.vent.trigger("fetch:kb:responseTypeUsage:language:change:increase");
        var validAdd = Messenger.reqres.request("fetch:kb:responseTypeUsage:valid");
        if (validAdd) {
          Messenger.vent.trigger("update:kb:language:add:clearInput");
        } else {
          Messenger.vent.trigger("view:admin:kbWizard:kbLocale:languages:delete", newLanguage);
          Messenger.vent.trigger("fetch:kb:responseTypeUsage:language:change:decrease");
          Messenger.okDialog("admin.kbAdmin.kbCreationLocalesResponseTypeUsageInvalid");
        }
      }
    },

    _setUpVents: function () {
      Messenger.vent.on(
        "add:admin:kbWizard:kbLocale:languages:add",
        function (language) {
          this.saveNewLanguage(language);
        },
        this,
      );

      Messenger.vent.on(
        "view:admin:kbWizard:kbLocale:languages:delete",
        function (language) {
          if (this.editMode) {
            language.deleteModel();
          } else {
            this.locales.remove(language);
          }
          this.layout.clearErrors();
        },
        this,
      );
    },
  });

  return KbLocalesListModule;
});
